import { Box, Button, HStack, Text } from "@chakra-ui/react";
import { formatDate, Select } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { SqlOperator } from "@src/__generated__/urql-graphql";
import { Icon } from "@src/components/ui-kit/Icon";
import { FilterPopover } from "@src/utils/components/filters/components/filter-popover";
import {
  createDateRangeFilters,
  type TableFilter,
} from "@src/utils/components/filters/factories";
import {
  Filter,
  Filters as FiltersModel,
} from "@src/utils/components/filters/models";
import { getCommonRanges } from "@src/utils/date-ranges";
import { fieldToSelectProps } from "@src/utils/forms/inputHelpers";
import { observer } from "mobx-react-lite";
import type React from "react";
import { type FunctionComponent, useContext } from "react";
import { PageProjectTimeReportCtx } from "./PageProjectTimeReport";

export const Filters: FunctionComponent<React.PropsWithChildren<object>> =
  observer(function Filters() {
    const store = useContext(PageProjectTimeReportCtx);
    const { fields } = store.form;

    const { filters } = new FiltersModel<any>(
      [
        new Filter({
          operator: SqlOperator.Between,
          dateRange: true,
          options: [],
          column: null,
          title:
            formatDate(fields.custom.value.start) +
            " - " +
            formatDate(fields.custom.value.end),
          value: [
            fields.custom.value.start.toDateString(),
            fields.custom.value.end.toDateString(),
          ],
        }),
      ],
      {
        onChange: (_change) => {
          if (!_change) return;

          const from = new Date(_change[0]);
          const to = new Date(_change[1]);

          const range = { start: from, end: to };

          fields.custom.onChange(range);
        },
      },
    );

    const filter: TableFilter = createDateRangeFilters(filters)[0];

    return (
      <HStack spacing="4">
        <HStack spacing="2">
          <Box minW="225px">
            <Select
              label=""
              {...fieldToSelectProps(fields.budgetItem, store.ourWorkOptions)}
            />
          </Box>
          {!store.monthlyBreakdownSelected && (
            <Select
              label=""
              {...fieldToSelectProps(fields.range, getCommonRanges())}
              menuMinWidth="150px"
            />
          )}
        </HStack>
        {!store.monthlyBreakdownSelected && fields.range.$ === "custom" && (
          <HStack spacing="2">
            <Text>
              <Trans>Choose date range</Trans>:
            </Text>
            <FilterPopover
              targetId={filter.key}
              trigger={
                <Button
                  colorScheme="grey"
                  rightIcon={<Icon name="chevron-down" />}
                  size="sm"
                  variant="ghost"
                >
                  {filter.label}
                </Button>
              }
              filter={filter}
            />
          </HStack>
        )}
      </HStack>
    );
  });
